// eslint-disable-next-line import/prefer-default-export
export const installationsGetters = {
    cur_install_id(state) {
        return state.cur_install_id
    },

    installations(state) {
        return state.installations
    },

    is_filtred_by_geo(state) {
        return state.is_filtred_by_geo
    }
};
